import { render, staticRenderFns } from "./MessagesSeparatorByDate.vue?vue&type=template&id=690e35f5"
import script from "./MessagesSeparatorByDate.vue?vue&type=script&lang=ts"
export * from "./MessagesSeparatorByDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690e35f5')) {
      api.createRecord('690e35f5', component.options)
    } else {
      api.reload('690e35f5', component.options)
    }
    module.hot.accept("./MessagesSeparatorByDate.vue?vue&type=template&id=690e35f5", function () {
      api.rerender('690e35f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/MessagesSeparatorByDate.vue"
export default component.exports